import Head from "next/head";
import { fetchGetBanners } from "../../../services/api";
import SingleBanner from "../../components/default/single-banner";
import InsurerForm from "../../components/insurer/insurer-form";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";

export default function InsurerPage({ companyGeneralData, banner }) {
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content="Revenda de veículos multimarcas, novos e semi-novos. Veículos com procedência e garantia." />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`${(companyGeneralData.company.nickName).toUpperCase()} - ${companyGeneralData.company.city ? companyGeneralData.company.city : ''} - Seguro`}</title>
            </Head>

            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                {banner ? <SingleBanner imageUrl={banner.imageUrl} /> : null}
                <InsurerForm />
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps() {
    const banners = await fetchGetBanners({ idMenuOption: 7 });

    return {
        props: {
            banner: (banners && banners.length > 0) ? banners[0].banner : null
        }
    }
}